import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../informationPopup/customModal';
import { LinearCloseCirlce } from '../icons';
import { getSubDescriptionForFeatureRequired } from '../../helpers/notification';
import { FeatureSelectionTab } from '../../interface/featureSelection';
import { IInAppNotification } from '../../interface';

interface FeatureModalProps {
  visible: boolean;
  featureToEnable?: FeatureSelectionTab;
  notification?: IInAppNotification;
  isRestrictedUserModal?: boolean;
  onClose: () => void;
  onConfirm: (featureToEnable?: FeatureSelectionTab, notification?: IInAppNotification) => void;
}

const FeatureModal: React.FC<FeatureModalProps> = ({
  visible,
  featureToEnable,
  notification,
  isRestrictedUserModal = false,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  if (!visible) return null;

  const handleConfirm = () => {
    onConfirm(featureToEnable, notification);
  };

  let subdescription: string | undefined;
  if (isRestrictedUserModal) {
    subdescription = undefined;
  } else if (featureToEnable) {
    subdescription = getSubDescriptionForFeatureRequired(featureToEnable, t);
  } else {
    subdescription = undefined;
  }

  return (
    <CustomModal
      visible={visible}
      title={
        isRestrictedUserModal
          ? t('common:features.invoicingSectionNotAllowedForRestrictedUser')
          : t('common:features.featureRequired')
      }
      subdescription={subdescription}
      icon={<LinearCloseCirlce />}
      confirmText={isRestrictedUserModal ? t('common:ok') : t('common:features.enable')}
      cancelText={isRestrictedUserModal ? undefined : t('common:no')}
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  );
};

export default FeatureModal;
